import { useRef, useEffect } from 'react'
import { useInViewport } from 'ahooks'

import clsx from 'clsx';

import { useBackgroundThemeActionsContext } from '../providers/BackgroundThemeProvider'

function Section({ nodeIndex, children, className }) {
  const setIndex = useBackgroundThemeActionsContext()
  const ref = useRef()
  const [inViewport] = useInViewport(ref, {
    rootMargin: '0px 0px -50% 0px',
    threshold: [0.01, 0.99]
  })

  useEffect(() => {
    if (!inViewport) return
    setIndex(nodeIndex)
  }, [inViewport, nodeIndex, setIndex])

  return (
    <section
      ref={ref}
      className={clsx(
        'rounded-default flex flex-col items-center overflow-hidden relative box-border h-[528px]',
        'md:h-[400px]',
        'lg:h-[546px]',
        'xl:h-[700px]',
        '2xl:h-[800px]',
        className
      )}
    >
      {children}
    </section>
  );
}

export default Section
